module.exports = __webpack_public_path__ + "static/media/a33.b39a5d9c.pdf";